import uuid from "../../../library/uuid.js";

import global from "../../global.js";

import {make_ids_unique} from "svg-utils";

const d3 = global.d3;

//const log = global.log.getLogger("f_mtac.scene.drivers.resource");

const Resource = function (group, resource) {
    this.data = {
        id: `local-${uuid()}`,
        class: ["node", "resource", "movable", "removable"],
        storage: "object"
    };
    this.group = group;
    this.resource = resource.cloneNode(true);
    make_ids_unique(global.svg.root.node(), this.resource);
    this.handle = null;
    this.node = null;
    this.figure = null;
    this.position = {x: 0, y: 0};
};
Resource.prototype.draw = function (x, y) {
    this.group.select(`#${this.data.id}`).remove();
    this.handle = this.group.append("g").attr("class", "handle").attr("id", this.data.id);
    this.handle.on("click", () => d3.event.preventDefault());
    this.node = this.handle.append("g").attr("class", this.data.class.join(" ")).attr("transform", `translate(${x},${y})`);
    this.node.attr("data-type", "resource");
    this.node.attr("data-subtype", "raw");
    this.node.append("g").attr("class", "color");
    this.node.append("g").attr("class", "name");
    this.node.append("g").attr("class", "user_name");
    this.node.append("g").attr("class", "stream");
    this.figure = this.node.append("g").attr("class", "figure");
    this.figure.append(() => this.resource).attr("transform", null);
    this.position.x = x;
    this.position.y = y;
};
Resource.prototype.replace = function (resource) {
    this.figure.html("");
    this.figure.append(() => resource).attr("transform", null);
    this.resource = resource;
};
Resource.prototype.center = function () {
    let base_element = this.figure.node();
    let position = this.handle.node().getBBox();
    let {x, y, width, height} = base_element.getBBox();
    let relative_position = {x: position.x + x + width / 2, y: position.y + y + height / 2};
    let element = base_element;
    while (element.parentNode !== null && element.parentNode !== this.handle.node()) {
        let {x, y} = element.parentNode.getBBox();
        relative_position.x -= x;
        relative_position.y -= y;
        element = element.parentNode;
    }
    return relative_position;
};
Resource.prototype.center_animation = function () {
    let base_element = this.figure.node();
    let position = this.handle.node().getBBox();
    let {x, y, width, height} = base_element.getBBox();
    let relative_position = {x: position.x + x + width / 2, y: position.y + y + height / 2};
    let element = base_element;
    while (element.parentNode !== null && element.parentNode !== this.handle.node()) {
        let {x, y} = element.parentNode.getBBox();
        relative_position.x -= x;
        relative_position.y -= y;
        element = element.parentNode;
    }
    return relative_position;
};
Resource.prototype.update = function (x, y) {
    this.node.attr("transform", `translate(${x},${y})`);
    this.position.x = x;
    this.position.y = y;
};
Resource.prototype.end = function () {
    this.handle.on("click", null);
    return Promise.resolve();
};
Resource.prototype.is_empty = function () {
    return false;
};
Resource.prototype.detach = function () {
    this.handle = null;
    this.node = null;
    this.figure = null;
};
Resource.prototype.export = function () {
    return this.handle;
};
export default Resource;
